import { call, delay, put, select } from 'redux-saga/effects';
import Api from '../../Api';
import Account from '../../helpers/Account';
import { unreadChannelsSet, unreadCountsSet } from '../actions/users';
import Cookies from 'js-cookie'

const POLL_MS = 5000;

/** Unread polling uses `api` (Bearer access_token). `/admin_login` (URS) only sets access_token_urs — never hit WA/TG for that session. */
function hasOperatorApiSession() {
  return !!Account.getAdminToken();
}

function* bootstrapChannels() {
  try {
    let whatsappEnabled = false;
    let telegramEnabled = false;
    let telegramMainId = null;

    try {
      const waRes = yield call(Api.whatsappGet);
      const waRows = waRes?.data?.data || [];
      whatsappEnabled = Array.isArray(waRows) && waRows.length > 0;
    } catch {
      whatsappEnabled = false;
    }

    try {
      const tgRes = yield call(Api.telegramGet);
      const tgRows = tgRes?.data?.data || tgRes?.data?.telegrams || tgRes?.data || [];
      const ids = (Array.isArray(tgRows) ? tgRows : [])
        .map((x) => Number(x?.id || x?.ID || 0))
        .filter((n) => Number.isFinite(n) && n > 0);
      telegramEnabled = ids.length > 0;
      telegramMainId = telegramEnabled ? ids[0] : null;
    } catch {
      telegramEnabled = false;
      telegramMainId = null;
    }

    yield put(unreadChannelsSet({ whatsappEnabled, telegramEnabled, telegramMainId }));
  } catch {
    // ignore bootstrap errors; loop continues
  }
}

export default function* watcher() {
  if(Cookies.get('viewer')){
    return
  }
  while (true) {
    while (!hasOperatorApiSession()) {
      yield delay(POLL_MS);
    }

    yield* bootstrapChannels();

    while (hasOperatorApiSession()) {
      try {
        const users = yield select((state) => state.users || {});
        const whatsappEnabled = !!users.unreadWhatsappEnabled;
        const telegramEnabled = !!users.unreadTelegramEnabled;
        let whatsappUnread = 0;
        let telegramUnread = 0;

        if (whatsappEnabled) {
          try {
            const waRes = yield call(Api.whatsappUnreadTotal);
            whatsappUnread = Number(waRes?.data?.total || 0);
          } catch {
            whatsappUnread = 0;
          }
        }

        if (telegramEnabled) {
          try {
            const tgRes = yield call(Api.telegramUnreadTotalAllForMember);
            telegramUnread = Number(tgRes?.data?.total || 0);
          } catch {
            telegramUnread = 0;
          }
        }

        yield put(unreadCountsSet({ whatsappUnread, telegramUnread }));
      } catch {
        // keep loop alive
      }

      yield delay(POLL_MS);
    }

    yield put(
      unreadChannelsSet({
        whatsappEnabled: false,
        telegramEnabled: false,
        telegramMainId: null,
      })
    );
    yield put(unreadCountsSet({ whatsappUnread: 0, telegramUnread: 0 }));
  }
}

